import { getUserData } from "./auth-reducer";

const INITIAL_SUCCESS = 'app/INITIAL_SUCCESS'



let initialState = {
  initialized: false
}

const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_SUCCESS:
      return ({
        ...state,
        initialized: true
      });
    default:
      return state;
  }
}

const setInitial = () => ({ type: INITIAL_SUCCESS })


export const initializeApp = () => async (dispatch) => {

  await dispatch(getUserData());
  dispatch(setInitial())
}



export default appReducer;